import "../../App.css";
import { useCallback, useEffect, useRef, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Dropdown, Menu } from "antd";
import { useAuth } from "../AuthContext";
import axios from "axios";
import Appconfig from "../../config/config";
import { useSelector, useDispatch } from "react-redux";
import UserAutoLogout from "../../pages/userAutoLogout";
// import { getUserBal } from '../../redux/slice/user/userSlice'
import { WebSocketContext } from '../../context/websocket';
import { NavLink, useNavigate } from "react-router-dom";
import { FaBars, FaSearchPlus } from "react-icons/fa";
import "./Header.css";

const LIVE_MARKET_ITEMS = [
  { label: "Premium Casino", path: "/premium-casino" },
  { label: "Tembo Casino", path: "/tembo-casino" },
  { label: "VIP Casino", path: "/vip-casino" },
  { label: "Lucky 6", path: "/casino/lucky-6" },
  { label: "Mogambo", path: "/casino/mogambo" },
  { label: "Unique Teenpatti", path: "/casino/unique-teenpatti" },
  { label: "Roulette", path: "/casino/roulette" },
  { label: "Super Over2", path: "/casino/super-over-2" },
  { label: "Lucky 15", path: "/casino/lucky-15" },
  { label: "Goal", path: "/casino/goal" },
  { label: "Goal 2", path: "/casino/goal-2" },
  { label: "Binary", path: "/casino/binary" },
  { label: "Race 20-20", path: "/casino/race-20-20" },
  { label: "Queen", path: "/casino/queen" },
  { label: "Baccarat", path: "/casino/baccarat" },
  { label: "Sport Casino", path: "/casino/sport-casino" },
  { label: "Casino War", path: "/casino/casino-war" },
  { label: "Worli", path: "/casino/worli" },
  { label: "3 Card Judgement", path: "/casino/3-card-judgement" },
];

const LIVE_VIRTUAL_MARKET_ITEMS = [
  { label: "20-20 DTL", path: "/virtual/20-20-dtl" },
  { label: "Amar Akbar Anthony", path: "/virtual/amar-akbar-anthony" },
  { label: "Muflis Teenpatti", path: "/virtual/muflis-teenpatti" },
  { label: "1 Day Teenpatti", path: "/virtual/1-day-teenpatti" },
  { label: "1 Day Dragon Tiger", path: "/virtual/1-day-dragon-tiger" },
  { label: "Lucky 7", path: "/virtual/lucky-7" },
  { label: "Bollywood Casino", path: "/virtual/bollywood-casino" },
  { label: "20-20 Teenpatti", path: "/virtual/20-20-teenpatti" },
  { label: "Trio", path: "/virtual/trio" },
];

const REPORT_ITEMS = [
  { label: "Account Statement", path: "/my-account/master" },
  { label: "Current Bets", path: "/betting" },
  { label: "Payment Methods", path: "/payment-methods" },
  { label: "Deposit Requests", path: "/deposit-request" },
  { label: "Withdraw Requests", path: "/withdraw-request" },
  { label: "Welcome Banner", path: "/welcome-banner" },
  { label: "Profit And Loss", path: "/profit-and-loss" },
  { label: "Admin Fund", path: "/adminFund" },
  { label: "General Lock", path: "/general-lock" },
  {
    label: "User General Setting",
    path: "/user-general-setting",
  },
  { label: "Total Profit Loss", path: "/total-profit-loss" },
  { label: "User Win Loss", path: "/user-win-loss" },
];

const SPORTS_MENU_ITEMS = [
  { id: "football", apiId: "1", name: "Football" },
  { id: "tennis", apiId: "2", name: "Tennis" },
  { id: "mixed-martial-arts", apiId: "mma", name: "Mixed Martial Arts" },
  { id: "cricket", apiId: "4", name: "Cricket" },
  { id: "golf", apiId: "3", name: "Golf" },
  { id: "boxing", apiId: "boxing", name: "Boxing" },
  { id: "beach-volleyball", apiId: "beach-volleyball", name: "Beach Volleyball" },
  { id: "table-tennis", apiId: "table-tennis", name: "Table Tennis" },
  { id: "futsal", apiId: "futsal", name: "Futsal" },
  { id: "horse-racing", apiId: "7", name: "Horse Racing" },
  { id: "e-games", apiId: "e-games", name: "E Games" },
  { id: "basketball", apiId: "basketball", name: "Basketball" },
  { id: "motogp", apiId: "motogp", name: "MotoGP" },
  { id: "chess", apiId: "chess", name: "Chess" },
  { id: "volleyball", apiId: "volleyball", name: "Volleyball" },
  { id: "ice-hockey", apiId: "ice-hockey", name: "Ice Hockey" },
  { id: "badminton", apiId: "badminton", name: "Badminton" },
  { id: "cycling", apiId: "cycling", name: "Cycling" },
  { id: "motorbikes", apiId: "motorbikes", name: "Motorbikes" },
  { id: "athletics", apiId: "athletics", name: "Athletics" },
  { id: "basketball-3x3", apiId: "basketball-3x3", name: "Basketball 3X3" },
  { id: "sumo", apiId: "sumo", name: "Sumo" },
  { id: "virtual-sports", apiId: "virtual-sports", name: "Virtual sports" },
  { id: "handball", apiId: "handball", name: "Handball" },
  { id: "politics", apiId: "politics", name: "Politics" },
];

const HEADER_NAV_ITEMS = [
  {
    label: "List of Clients",
    path: "/downline-list",
  },
  {
    label: "Assign Agent",
    path: "/assign-agent",
  },
  {
    label: "Market Analysis",
    path: "/market-analysis",
  },
  {
    label: "Live Market",
    children: [
      { label: "Sports Market", path: "/live-market" },
      { label: "Live Events", path: "/live-events" },
    ],
  },
  {
    label: "Live Virtual Market",
    children: [
      { label: "Virtual Market", path: "/virtual-market" },
      { label: "Casino Market", path: "/casino-market" },
    ],
  },
  {
    label: "Reports",
    children: [
      { label: "Account Statement", path: "/my-account/master" },
      { label: "Bet List", path: "/bet-list" },
      { label: "Profit/Loss", path: "/profit-loss" },
    ],
  },
  {
    label: "Multi Login",
    path: "/multi-login",
  },
];

function Header() {

  const navigate = useNavigate();
  const location = useLocation();

  const [clientSearch, setClientSearch] = useState("");

  const handleClientSearch = (event) => {
    event.preventDefault();

    const searchValue = clientSearch.trim();

    navigate(
      searchValue
        ? `/clients?search=${encodeURIComponent(
          searchValue
        )}`
        : "/clients"
    );
  };

  const [openDropdown, setOpenDropdown] = useState(null);
  const dropdownCloseTimer = useRef(null);

  const openHeaderDropdown = useCallback((dropdownName) => {
    if (dropdownCloseTimer.current) {
      clearTimeout(dropdownCloseTimer.current);
    }

    setOpenDropdown(dropdownName);
  }, []);

  const closeHeaderDropdown = useCallback(() => {
    if (dropdownCloseTimer.current) {
      clearTimeout(dropdownCloseTimer.current);
    }

    dropdownCloseTimer.current = setTimeout(() => {
      setOpenDropdown(null);
    }, 150);
  }, []);

  const toggleHeaderDropdown = useCallback((dropdownName) => {
    if (dropdownCloseTimer.current) {
      clearTimeout(dropdownCloseTimer.current);
    }

    setOpenDropdown((currentDropdown) =>
      currentDropdown === dropdownName
        ? null
        : dropdownName
    );
  }, []);

  const desktopHeaderRef = useRef(null);

  const toggleDropdown = useCallback((dropdownName) => {
    setOpenDropdown((currentDropdown) =>
      currentDropdown === dropdownName ? null : dropdownName
    );
  }, []);

  const closeDropdowns = useCallback(() => {
    setOpenDropdown(null);
  }, []);

  useEffect(() => {
    setOpenDropdown(null);

    if (dropdownCloseTimer.current) {
      clearTimeout(
        dropdownCloseTimer.current
      );

      dropdownCloseTimer.current = null;
    }
  }, [location.pathname]);

  const openMenuPage = useCallback(
    (path) => {
      if (dropdownCloseTimer.current) {
        clearTimeout(
          dropdownCloseTimer.current
        );

        dropdownCloseTimer.current = null;
      }

      setOpenDropdown(null);
      setMobileMenuOpen(false);
      setExpandedSportId(null);

      navigate(path);
    },
    [navigate]
  );

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [expandedSportId, setExpandedSportId] = useState(null);
  const [sportCompetitions, setSportCompetitions] = useState({});
  const [sportsMenuLoading, setSportsMenuLoading] = useState({});
  const [sportsMenuError, setSportsMenuError] = useState({});

  const closeSportsMenu = useCallback(() => {
    setMobileMenuOpen(false);
    setExpandedSportId(null);
  }, []);

  useEffect(() => {
    if (!mobileMenuOpen) {
      document.body.style.overflow = "";
      return undefined;
    }

    document.body.style.overflow = "hidden";

    const handleEscapeKey = (event) => {
      if (event.key === "Escape") {
        closeSportsMenu();
      }
    };

    document.addEventListener("keydown", handleEscapeKey);

    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [mobileMenuOpen, closeSportsMenu]);

  const getSportCompetitions = useCallback(
    async (sport) => {
      if (sportCompetitions[sport.id]) {
        return;
      }

      setSportsMenuLoading((previous) => ({
        ...previous,
        [sport.id]: true,
      }));

      setSportsMenuError((previous) => ({
        ...previous,
        [sport.id]: "",
      }));

      try {
        const response = await axios.get(
          `${Appconfig.apiUrl}sports/${sport.apiId}/competitions`,
          {
            headers: {
              "Content-Type": "application/json",
            },
            params: {
              site_code: Appconfig.sitecodes,
            },
          }
        );

        /*
          Expected response:
  
          {
            "result": true,
            "resultData": [
              {
                "id": "101",
                "name": "Caribbean Premier League"
              }
            ]
          }
        */

        const competitions = Array.isArray(response.data?.resultData)
          ? response.data.resultData
          : [];

        setSportCompetitions((previous) => ({
          ...previous,
          [sport.id]: competitions,
        }));
      } catch (error) {
        console.error("Unable to load sport competitions:", error);

        setSportsMenuError((previous) => ({
          ...previous,
          [sport.id]: "Data not found",
        }));
      } finally {
        setSportsMenuLoading((previous) => ({
          ...previous,
          [sport.id]: false,
        }));
      }
    },
    [sportCompetitions]
  );

  const handleSportToggle = useCallback(
    async (sport) => {
      const isAlreadyOpen = expandedSportId === sport.id;

      if (isAlreadyOpen) {
        setExpandedSportId(null);
        return;
      }

      setExpandedSportId(sport.id);
      await getSportCompetitions(sport);
    },
    [expandedSportId, getSportCompetitions]
  );

  const handleCompetitionClick = useCallback(
    (sport, competition) => {
      closeSportsMenu();

      navigate(
        `/sports/${sport.apiId}/competition/${competition.id}`
      );
    },
    [navigate, closeSportsMenu]
  );

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        desktopHeaderRef.current &&
        !desktopHeaderRef.current.contains(event.target)
      ) {
        closeDropdowns();
      }
    };

    const handleEscapeKey = (event) => {
      if (event.key === "Escape") {
        closeDropdowns();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("keydown", handleEscapeKey);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [closeDropdowns]);

  useEffect(() => {
    return () => {
      if (dropdownCloseTimer.current) {
        clearTimeout(dropdownCloseTimer.current);
      }
    };
  }, []);

  const websocket = useContext(WebSocketContext);

  const dispatch = useDispatch();
  UserAutoLogout();
  // const userbal = useSelector((state) => state.userbal); // Use selector to access state
  // const balance = userbal?.userBalance?.balance;
  // const loading = userbal?.loading;

  const [loadBalance, setLoadBalance] = useState(false);
  const [balance, setBalance] = useState(0);
  const [withdrawCount, setWithdrawCount] = useState(0);
  const [depositCount, setDepositCount] = useState(0);
  const [showLogoutModal, setShowLogoutModal] = useState(false);


  const userInfo = JSON.parse(localStorage.getItem("userdata"));
  const { logout } = useAuth();

  const initialNavItems = [
    {
      title: "Dashboard ",
      url: "/",
      routerId: ["/"],
    },
    {
      title: "Downline List ",
      url: "",
      routerId: ["/list/user", "/list/master"],
      submenu: [
        {
          title: "User Downline List",
          url: "/list/user",
        },
        {
          title: "Master Downline List",
          url: `/list/master`,
        },
      ],
    },
    {
      title: "My Account ",
      url: "/my-account/master",
      routerId: ["/my-account/master"],
    },
    {
      title: "My Report",
      url: "",
      routerId: ["/reports/profit-loss", "/reports/downline-pl"],
      submenu: [
        {
          title: "Event Profit/Loss ",
          url: "/reports/profit-loss",
        },
        {
          title: "Downline Profit/Loss",
          url: "/reports/downline-pl",
        },
      ],
    },
    {
      title: "BetList ",
      url: "/bet-list",
      routerId: ["/bet-list"],
    },
    {
      title: "Market Analysis ",
      url: "/market-analysis",
      routerId: ["/market-analysis"],
    },
    {
      title: "Banking",
      url: "",
      routerId: ["/user-banking", "/master-banking"],
      submenu: [
        {
          title: "User Banking",
          url: "/user-banking",
        },
        {
          title: "Master Banking",
          url: "/master-banking",
        },
      ],
    },
    {
      title: "Payments",
      url: "",
      routerId: ["/payment-methods"],
      submenu: [
        {
          title: "Payment Setup",
          url: "/payment-methods",
        },
        {
          title: "Deposit Request",
          url: "/deposit-request",
        },
        {
          title: "Withdraw Request",
          url: "/withdraw-request",
        },
      ],
    },
    {
      title: "Commission ",
      url: "/commission",
      routerId: ["/commission"],
    },
    {
      title: "Password History",
      url: "/password-history",
      routerId: ["/password-history"],
    },
    {
      title: "Restore User ",
      url: "/restore-user",
      routerId: ["/restore-user"],
    },
  ];
  let navItems = [...initialNavItems];
  const initialNavItemsForMobile = [
    {
      title: "Dashboard ",
      url: "/",
      routerId: ["/"],
    },
    {
      title: "Downline List ",
      url: "",
      routerId: ["/list/user", `/list/master`],
      submenu: [
        {
          key: "1",
          label: <Link to={"/list/user"}>User Downline List</Link>,
        },
        {
          key: "2",
          label: <Link to={`/list/master`}>Master Downline List</Link>,
        },
      ],
    },
    {
      title: "My Account ",
      url: "/my-account/master",
      routerId: ["/my-account/master"],
    },
    {
      title: "My Report",
      url: "",
      routerId: ["/reports/profit-loss", "/reports/downline-pl"],
      submenu: [
        {
          key: "1",
          label: <Link to={"/reports/profit-loss"}>Event Profit/Loss</Link>,
        },
        {
          key: "2",
          label: <Link to={"/reports/downline-pl"}>Downline Profit/Loss</Link>,
        },
      ],
    },
    {
      title: "BetList ",
      url: "/bet-list",
      routerId: ["/bet-list"],
    },
    {
      title: "Market Analysis ",
      url: "/market-analysis",
      routerId: ["/market-analysis"],
    },
    {
      title: "Banking",
      url: "",
      routerId: ["/user-banking", "/master-banking"],
      submenu: [
        {
          key: "1",
          label: <Link to={"/user-banking"}>User Banking</Link>,
        },
        {
          key: "2",
          label: <Link to={"/master-banking"}>Master Banking</Link>,
        },
      ],
    },
    {
      title: "Payments",
      url: "",
      routerId: ["/payment-methods"],
      submenu: [
        {
          key: "1",
          label: <Link to={"/payment-methods"}>Payment Setup</Link>,
        },
        {
          key: "2",
          label: (
            <Link to={"/deposit-request"}>
              Deposit Request
              {depositCount > 0 && (
                <span className="absolute top-0 right-0 bg-red-500 text-white text-xs font-bold w-4 h-4 flex items-center justify-center rounded-full">
                  {depositCount}
                </span>
              )}
            </Link>
          ),
        },
        {
          key: "3",
          label: (
            <Link to={"/withdraw-request"}>
              Withdraw Request
              {withdrawCount > 0 && (
                <span className="absolute top-0 right-0 bg-red-500 text-white text-xs font-bold w-4 h-4 flex items-center justify-center rounded-full">
                  {withdrawCount}
                </span>
              )}
            </Link>
          ),
        },
      ],
    },

    {
      title: "Commission ",
      url: "/commission",
      routerId: ["/commission"],
    },
    {
      title: "Password History",
      url: "/password-history",
      routerId: ["/password-history"],
    },
    {
      title: "Restore User ",
      url: "/restore-user",
      routerId: ["/restore-user"],
    },
  ];

  let navItemsForMobile = [...initialNavItemsForMobile];

  if (userInfo?.user_type === "Super Admin") {
    navItems.push({
      title: "My Setting",
      url: "",
      routerId: [
        "/adminfund",
        "/news",
        `/user-general-setting/${userInfo?._id}`,
        `add-domain`,
      ],
      submenu: [
        {
          title: "Admin Fund ",
          url: "/adminfund",
        },
        {
          title: "News ",
          url: "/news",
        },
        {
          title: "User General Setting ",
          url: `/user-general-setting/${userInfo?._id}`,
        },
        {
          title: "Block Market ",
          url: "/block-market",
        },
        {
          title: "Event Wise Setting ",
          url: `/event-user-general-setting`,
        },
        {
          title: "Add Domain ",
          url: `/add-domain`,
        },
        {
          title: "Betting ",
          url: `/betting`,
        },
        {
          title: "Add Banner ",
          url: `/banner`,
        },
        {
          title: "Add Number ",
          url: `/supportNumber`,
        },
        {
          title: "Casino Uses ",
          url: `/casino-uses`,
        },
      ],
    });
    navItemsForMobile.push({
      title: "My Setting",
      url: "",
      routerId: [
        "/adminfund",
        "/news",
        `/user-general-setting/${userInfo?._id}`,
        `/event-user-general-setting`,
        `/add-domain`,
      ],
      submenu: [
        {
          key: "1",
          label: <Link to={"/adminfund"}>Admin Fund</Link>,
        },
        {
          key: "2",
          label: <Link to={"/news"}>News</Link>,
        },
        {
          key: "3",
          label: (
            <Link to={`/user-general-setting/${userInfo?._id}`}>
              User General Setting
            </Link>
          ),
        },
        {
          key: "4",
          label: <Link to={"/block-market"}>Block Market</Link>,
        },
        {
          key: "5",
          label: (
            <Link to={"/event-user-general-setting"}>
              Event Wise User General Setting
            </Link>
          ),
        },
        {
          key: "6",
          label: <Link to={"/add-domain"}>Add Domain</Link>,
        },
        {
          key: "7",
          label: <Link to={"/betting"}>Betting</Link>,
        },
        {
          key: "8",
          label: <Link to={"/banner"}>Add Banner</Link>,
        },
        {
          key: "9",
          label: <Link to={"/supportNumber"}>Add Number</Link>,
        },
        {
          key: "10",
          label: <Link to={"/casino-uses"}>Casino Uses</Link>,
        },
      ],
    });
  }

  if (userInfo?.user_type === "Admin") {
    navItems.push({
      title: "My Setting",
      url: "",
      routerId: [
        "/adminfund",
        "/news",
        `/user-general-setting/${userInfo?._id}`,
        `add-domain`,
      ],
      submenu: [
        {
          title: "Admin Fund ",
          url: "/adminfund",
        },
        {
          title: "News ",
          url: "/news",
        },
        {
          title: "User General Setting ",
          url: `/user-general-setting/${userInfo?._id}`,
        },
        {
          title: "Block Market ",
          url: "/block-market",
        },
        {
          title: "Event Wise Setting ",
          url: `/event-user-general-setting`,
        },
        // {
        //   title: "Add Domain ",
        //   url: `/add-domain`,
        // },
        {
          title: "Betting ",
          url: `/betting`,
        },
        {
          title: "Add Banner ",
          url: `/banner`,
        },
        {
          title: "Add Number ",
          url: `/supportNumber`,
        },
        // {
        //   title: "Casino Uses ",
        //   url: `/casino-uses`,
        // },
      ],
    });
    navItemsForMobile.push({
      title: "My Setting",
      url: "",
      routerId: [
        "/adminfund",
        "/news",
        `/user-general-setting/${userInfo?._id}`,
        `/event-user-general-setting`,
        `/add-domain`,
      ],
      submenu: [
        // {
        //   key: "1",
        //   label: <Link to={"/adminfund"}>Admin Fund</Link>,
        // },
        {
          key: "2",
          label: <Link to={"/news"}>News</Link>,
        },
        {
          key: "3",
          label: (
            <Link to={`/user-general-setting/${userInfo?._id}`}>
              User General Setting
            </Link>
          ),
        },
        {
          key: "4",
          label: <Link to={"/block-market"}>Block Market</Link>,
        },
        {
          key: "5",
          label: (
            <Link to={"/event-user-general-setting"}>
              Event Wise User General Setting
            </Link>
          ),
        },
        {
          key: "6",
          label: <Link to={"/add-domain"}>Add Domain</Link>,
        },
        // {
        //   key: "7",
        //   label: <Link to={"/betting"}>Betting</Link>,
        // },
        {
          key: "8",
          label: <Link to={"/banner"}>Add Banner</Link>,
        },
        {
          key: "9",
          label: <Link to={"/supportNumber"}>Add Number</Link>,
        },
        // {
        //   key: "10",
        //   label: <Link to={"/casino-uses"}>Casino Uses</Link>,
        // },
      ],
    });
  }

  const scrollableGamesListRef = useRef(null);
  const scrollNav = (index) => {
    const itemElement = scrollableGamesListRef.current.querySelector(
      `#item-${index}`
    );
    if (itemElement) {
      itemElement.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  };

  function getBalance() {
    var data = JSON.stringify({
      user_id: userInfo?._id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}ledger/getUserBalance`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result == 0) {
        } else {
          setBalance(response.data.resultData.balance);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  function getDWRequest() {
    var data = JSON.stringify({
      user_id: userInfo?._id,
      site_code: Appconfig.sitecodes,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}deposit/getDWCount`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result) {
          setDepositCount(response.data.resultData.depositCount);
          setWithdrawCount(response.data.resultData.withdrawCount);
          // console.log('response.data',response.data.resultData);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  // function getBalance() {
  //     if (userInfo) {
  //         dispatch(getUserBal({
  //             user_id: userInfo?._id,
  //         }))
  //     }
  // }

  // useEffect(() => {
  //     if (userInfo) {
  //         dispatch(getUserBal({
  //             user_id: userInfo?._id,
  //         }))
  //     }

  // }, [userInfo?._id])

  useEffect(() => {
    getBalance();
    getDWRequest();
  }, [userInfo]);

  return (
    <header ref={desktopHeaderRef} className="admin-reference-header">
      <div className="admin-header-inner">
        {/* Logo */}
        <NavLink
          to="/dashboard"
          className="admin-header-logo"
          onClick={() => setMobileMenuOpen(false)}
        >
          <img
            src={`${process.env.PUBLIC_URL}/logo.png`}
            alt="BMW EXCH"
          />
        </NavLink>

        {/* Hamburger */}
        <button
          type="button"
          className={[
            "admin-menu-toggle",
            mobileMenuOpen ? "admin-menu-toggle-open" : "",
          ]
            .filter(Boolean)
            .join(" ")}
          onClick={() => {
            setMobileMenuOpen((previous) => !previous);
            setExpandedSportId(null);
          }}
          aria-label="Toggle navigation"
          aria-expanded={mobileMenuOpen}
        >
          <i className="fas fa-bars" aria-hidden="true" />
        </button>

        <div
          className={[
            "sports-menu-overlay",
            mobileMenuOpen ? "sports-menu-overlay-open" : "",
          ]
            .filter(Boolean)
            .join(" ")}
          onClick={closeSportsMenu}
          aria-hidden="true"
        />

        <aside
          className={[
            "sports-side-menu",
            mobileMenuOpen ? "sports-side-menu-open" : "",
          ]
            .filter(Boolean)
            .join(" ")}
          aria-label="Sports navigation"
          aria-hidden={!mobileMenuOpen}
        >
          <div className="sports-side-menu-header">
            <h2>Sports</h2>

            <button
              type="button"
              className="sports-side-menu-close"
              onClick={closeSportsMenu}
              aria-label="Close sports menu"
            >
              &times;
            </button>
          </div>

          <div className="sports-side-menu-content">
            {SPORTS_MENU_ITEMS.map((sport) => {
              const isExpanded = expandedSportId === sport.id;
              const competitions = sportCompetitions[sport.id] || [];
              const isLoading = sportsMenuLoading[sport.id];
              const errorMessage = sportsMenuError[sport.id];

              return (
                <div className="sports-menu-sport" key={sport.id}>
                  <button
                    type="button"
                    className="sports-menu-sport-button"
                    onClick={() => handleSportToggle(sport)}
                    aria-expanded={isExpanded}
                  >
                    <span>{sport.name}</span>

                    <span
                      className="sports-menu-sign"
                      aria-hidden="true"
                    >
                      {isExpanded ? "−" : "+"}
                    </span>
                  </button>

                  {isExpanded && (
                    <div className="sports-menu-competitions">
                      {isLoading && (
                        <div className="sports-menu-message">
                          Loading...
                        </div>
                      )}

                      {!isLoading && errorMessage && (
                        <div className="sports-menu-message sports-menu-error">
                          {errorMessage}
                        </div>
                      )}

                      {!isLoading &&
                        !errorMessage &&
                        competitions.length === 0 && (
                          <div className="sports-menu-message">
                            No competitions available
                          </div>
                        )}

                      {!isLoading &&
                        competitions.map((competition) => (
                          <button
                            type="button"
                            className="sports-menu-competition-button"
                            key={competition.id}
                            onClick={() =>
                              handleCompetitionClick(
                                sport,
                                competition
                              )
                            }
                          >
                            <span className="sports-menu-tree-dot" />

                            <span className="sports-menu-competition-name">
                              {competition.name}
                            </span>

                            <span
                              className="sports-menu-sign"
                              aria-hidden="true"
                            >
                              +
                            </span>
                          </button>
                        ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </aside>

        {/* Navigation */}
        <nav
          className="admin-desktop-navigation"
          aria-label="Administrator navigation"
        >
          <button
            type="button"
            className="admin-nav-item"
            onClick={() => openMenuPage("/clients")}
          >
            List of Clients
          </button>

          <button
            type="button"
            className="admin-nav-item"
            onClick={() => openMenuPage("/assign-agent")}
          >
            Assign Agent
          </button>

          <button
            type="button"
            className="admin-nav-item"
            onClick={() => openMenuPage("/market-analysis")}
          >
            Market Analysis
          </button>

          <div
            className={[
              "admin-header-dropdown",
              openDropdown === "live-market" ? "is-open" : "",
            ]
              .filter(Boolean)
              .join(" ")}
            onMouseEnter={() =>
              openHeaderDropdown("live-market")
            }
            onMouseLeave={closeHeaderDropdown}
          >
            <button
              type="button"
              className="admin-header-nav-button"
              onClick={() =>
                toggleHeaderDropdown("live-market")
              }
              aria-expanded={
                openDropdown === "live-market"
              }
            >
              <span>Live Market</span>
              <i
                className="fas fa-caret-down"
                aria-hidden="true"
              />
            </button>

            <div className="admin-header-dropdown-menu">
              <button type="button">Premium Casino</button>
              <button type="button">Tembo Casino</button>
              <button type="button">Vip Casino</button>
              <button type="button">Lucky 6</button>
              <button type="button">Mogambo</button>
              <button type="button">Unique Teenpatti</button>
              <button type="button">Roulette</button>
              <button type="button">Super Over2</button>
            </div>
          </div>

          <div
            className={[
              "admin-header-dropdown",
              openDropdown === "live-virtual-market"
                ? "is-open"
                : "",
            ]
              .filter(Boolean)
              .join(" ")}
            onMouseEnter={() =>
              openHeaderDropdown("live-virtual-market")
            }
            onMouseLeave={closeHeaderDropdown}
          >
            <button
              type="button"
              className="admin-header-nav-button"
              onClick={() =>
                toggleHeaderDropdown(
                  "live-virtual-market"
                )
              }
              aria-expanded={
                openDropdown === "live-virtual-market"
              }
            >
              <span>Live Virtual Market</span>
              <i
                className="fas fa-caret-down"
                aria-hidden="true"
              />
            </button>

            <div className="admin-header-dropdown-menu">
              <button type="button">20-20 DTL</button>
              <button type="button">
                Amar Akbar Anthony
              </button>
              <button type="button">
                Muflis Teenpatti
              </button>
              <button type="button">
                1 Day Teenpatti
              </button>
              <button type="button">
                1 Day Dragon Tiger
              </button>
              <button type="button">Lucky 7</button>
              <button type="button">
                Bollywood Casino
              </button>
              <button type="button">
                20-20 Teenpatti
              </button>
              <button type="button">Trio</button>
            </div>
          </div>

          <div
            className={[
              "admin-header-dropdown",
              openDropdown === "reports"
                ? "is-open"
                : "",
            ]
              .filter(Boolean)
              .join(" ")}
            onMouseEnter={() =>
              openHeaderDropdown("reports")
            }
            onMouseLeave={closeHeaderDropdown}
          >
            <button
              type="button"
              className="admin-header-nav-button"
              onClick={() =>
                toggleHeaderDropdown("reports")
              }
              aria-expanded={
                openDropdown === "reports"
              }
            >
              <span>Reports</span>
              <i
                className="fas fa-caret-down"
                aria-hidden="true"
              />
            </button>

            <div className="admin-header-dropdown-menu">
              <button
                type="button"
                onClick={() =>
                  openMenuPage("/my-account/master")
                }
              >
                Account Statement
              </button>
              <button
                type="button"
                onClick={() =>
                  openMenuPage("/betting")
                }
              >
                Current Bets
              </button>
              <button
                type="button"
                onClick={() =>
                  openMenuPage("/payment-methods")
                }
              >
                Payment Methods
              </button>
              <button
                type="button"
                onClick={() =>
                  openMenuPage("/deposit-request")
                }
              >
                Deposit Requests
              </button>
              <button
                type="button"
                onClick={() =>
                  openMenuPage("/withdraw-request")
                }
              >
                Withdraw Requests
              </button>
              <button
                type="button"
                onClick={() =>
                  openMenuPage("/welcome-banner")
                }
              >
                Welcome Banner
              </button>
              <button type="button">
                Profit And Loss
              </button>
              <button
                type="button"
                onClick={() =>
                  openMenuPage("/adminFund")
                }
              >
                Admin Fund
              </button>
              {/* <button type="button">
                General Lock
              </button> */}
              <button
                type="button"
                onClick={() =>
                  openMenuPage(
                    `/user-general-setting/${userInfo?._id}`
                  )
                }
              >
                User General Setting
              </button>
              <button type="button">
                Total Profit Loss
              </button>
              <button type="button">
                User Win Loss
              </button>
            </div>
          </div>

          <button
            type="button"
            className="admin-nav-item"
            onClick={() => openMenuPage("/multi-login")}
          >
            Multi Login
          </button>
        </nav>

        {/* Right controls */}
        <div className="admin-header-actions">

          {/* Existing Profile Dropdown - SAME AS SECOND CODE */}
          <div className="admin-nav-dropdown admin-profile-dropdown">
            <button
              type="button"
              className={`admin-profile-trigger ${openDropdown === "profile" ? "active" : ""
                }`}
              onClick={() => toggleDropdown("profile")}
              aria-expanded={openDropdown === "profile"}
            >
              <span>{userInfo?.user_name || "User"}</span>
              <i className="fas fa-caret-down" aria-hidden="true" />
            </button>

            {openDropdown === "profile" && (
              <div className="admin-dropdown-menu admin-profile-menu">
                <button
                  type="button"
                  className="admin-dropdown-option"
                  onClick={() => openMenuPage("/secure-auth-verification")}
                >
                  Secure Auth Verification
                </button>

                <button
                  type="button"
                  className="admin-dropdown-option"
                  onClick={() => openMenuPage("/change-password")}
                >
                  Change Password
                </button>

                <button
                  type="button"
                  className="admin-dropdown-option admin-logout-option"
                  onClick={() => {
                    closeDropdowns();
                    logout();
                  }}
                >
                  Logout
                </button>
              </div>
            )}
          </div>

          {/* Search Bar - FROM FIRST CODE */}
          <form
            className="admin-client-search"
            onSubmit={(event) => {
              event.preventDefault();

              const value =
                event.currentTarget.elements.clientSearch.value.trim();

              navigate(
                value
                  ? `/clients?search=${encodeURIComponent(
                    value
                  )}`
                  : "/clients"
              );
            }}
          >
            <input
              type="search"
              name="clientSearch"
              placeholder="All Client"
              aria-label="Search client"
            />

            <button type="submit" aria-label="Search">
              <i
                className="fas fa-search-plus"
                aria-hidden="true"
              />
            </button>
          </form>

        </div>
      </div>
    </header>
  );
}

export default Header;
